import React, { useState } from "react";
import Modal from "react-modal";
import CustomModal from "../../../components/CustomModal";
import UrgentRequestModal from "../../../components/UrgentRequestModal";
import { useTranslation } from "react-i18next";

const UrgentBtn = () => {
  const [confirmIsShown, setConfirmIsShown] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <button
        className="btnRounded w-100"
        onClick={() => setConfirmIsShown(true)}
      >
        {t("buttons.emergency")}
      </button>

      <CustomModal
        isOpen={confirmIsShown}
        onRequestClose={() => setConfirmIsShown(false)}
      >
        <UrgentRequestModal cancelRequest={() => setConfirmIsShown(false)} />
      </CustomModal>
    </>
  );
};

export default UrgentBtn;
